import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@adsk/bim360-matrix-react-svg-icon';
import Button from '@adsk/bim360-matrix-react-button';

import objectValues from '@adsk/bim360-matrix-react-helpers/es/objectValues';

/**
 * A button which contains an svg icon
 */
export default class IconButton extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      children,
      className,
      iconWidth,
      iconHeight,
      iconTransform,
      svgId,
      styleType,
      ...buttonProps
    } = this.props;

    return (
      <Button className={className} styleType={styleType} {...buttonProps}>
        {children || (
          <SvgIcon width={iconWidth} height={iconHeight} svgId={svgId} transform={iconTransform} />
        )}
      </Button>
    );
  }
}

IconButton.StyleType = {
  DEFAULT: Button.StyleType.ICON,
  MINIMAL: Button.StyleType.ICON_MINIMAL
};

IconButton.defaultProps = {
  styleType: IconButton.StyleType.DEFAULT,
  iconWidth: '16px',
  iconHeight: '16px',
  type: 'button'
};

IconButton.propTypes = {
  /**
   * The svg id to display as the icon. The id corresponds to an svg file in the SvgStore
   */
  svgId: PropTypes.string,
  /**
   * A node to be used as the button's icon. This property can be used to pass a svg that is not part of the SvgStore,
   * or in case the SvgStore is not used
   */
  children: PropTypes.node,
  /**
   * The kind of style for the IconButton. Can be one of IconButton.StyleType. Default to DEFAULT
   */
  styleType: PropTypes.oneOf(objectValues(IconButton.StyleType)),
  /**
   * The icon width
   */
  iconWidth: PropTypes.string,
  /**
   * The icon height
   */
  iconHeight: PropTypes.string,
  /**
   * An transform value for svg element
   */
  iconTransform: PropTypes.string,
  /**
   * A custom className
   */
  className: PropTypes.string,
  /**
   * Boolean indicator if we want to force hover state
   * (Isn't used here, but for legacy reasons `DropdownMenu` adds this to this component)
   */
  hovered: PropTypes.bool,
  /**
   * The HTML type attribute of the button, default to 'button'.
   */
  type: PropTypes.string
};
